import userBucketedInExperiment from '../../../modules/utils/experiments';

const inquiringForRadioButtons = document.querySelectorAll('input[name="inquiring-for"]');
const companyFields = document.querySelectorAll('input[id="custom_form_entry_company"]');
const moreThanOneCompanyField = companyFields.length > 1;
const granularConsentFields = document.querySelectorAll('.js-custom-form__granular-consent');
const showGranularConsentFields = () => granularConsentFields?.forEach(e => e.classList.remove('hidden'));
const hideGranularConsentFields = () => granularConsentFields?.forEach(e => e.classList.add('hidden'));

if (moreThanOneCompanyField) { companyFields[1].remove(); }

inquiringForRadioButtons.forEach((radioButton) => {
  radioButton.onclick = function anchorHandler () {
    const radioButtonValue = this.value;
    const workExperienceDiv = document.querySelector('.custom_form_entry_work_experience');
    const workExperienceField = document.querySelector('#custom_form_entry_work_experience');
    const salaryRangeDiv = document.querySelector('.custom_form_entry_annual_salary_range');
    const salaryRangeField = document.querySelector('#custom_form_entry_annual_salary_range');
    const companyDiv = document.querySelector('.custom_form_entry_company');
    const companyField = document.querySelector('#custom_form_entry_company');
    const numberOfParticipantsDiv = document.querySelector('.custom_form_entry_number_of_participants');
    const numberOfParticipantsField = document.querySelector('#custom_form_entry_number_of_participants');
    const hiddenInquiringForField = document.querySelector('#custom_form_entry_inquiring_for');
    const countrySelect = this.form.querySelector('.js-custom-form [type="country"]');

    if (radioButtonValue === 'myself') {
      if (workExperienceDiv && workExperienceField) {
        workExperienceDiv.classList.remove('hidden');
        workExperienceField.required = true;
      }
      if (salaryRangeDiv && salaryRangeField) {
        salaryRangeDiv.classList.remove('hidden');
        salaryRangeField.required = true;
      }
      if (!moreThanOneCompanyField) { companyDiv.classList.add('hidden'); }
      companyField.required = moreThanOneCompanyField;
      numberOfParticipantsDiv.classList.add('hidden');
      numberOfParticipantsField.required = false;
      hiddenInquiringForField.value = 'myself';

      if (userBucketedInExperiment('e20231226_granular_consent:variant')) {
        showGranularConsentFields();
      }
    }

    if (radioButtonValue === 'team') {
      if (workExperienceDiv && workExperienceField) {
        workExperienceDiv.classList.add('hidden');
        workExperienceField.required = false;
      }
      if (salaryRangeDiv && salaryRangeField) {
        salaryRangeDiv.classList.add('hidden');
        salaryRangeField.required = false;
      }
      companyDiv.classList.remove('hidden');
      companyField.required = true;
      numberOfParticipantsDiv.classList.remove('hidden');
      numberOfParticipantsField.required = true;
      hiddenInquiringForField.value = 'team';

      if (userBucketedInExperiment('e20231226_granular_consent:variant')) {
        hideGranularConsentFields();
      }
    }

    countrySelect.dispatchEvent(new CustomEvent('change'));
  };
});
